import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Top extends Vue {
  private message = 'メニューを選択してください'
}